module.exports = __webpack_public_path__ + "img/icon-speed-1.4e459615.svg";